import Ws from '@adonisjs/websocket-client';

const ws = Ws('wss://teste.leadflow.digital');

export default ws;
